import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';
import Image from '@eliadmin/core/src/components/image/image-wrapped';
import Link from '@eliadmin/core/src/components/link';

import type { CategoriesEntity } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { MdOutlineKeyboardArrowRight } from 'react-icons/md';

export function CategoryCard({
  category,
  onClick,
}: {
  category: CategoriesEntity;
  onClick?: () => void;
}) {
  return (
    <Link
      prefetch={false}
      href={ROUTES.CATEGORY({ slug: category.slug })}
      onClick={onClick ? onClick : undefined}
      className={cn(
        'col-span-1 flex w-full items-center justify-between border border-border p-6',
        'transition-all hover:bg-border',
      )}
    >
      <div className="flex items-center justify-start gap-3">
        <Image
          src={category?.icon?.url ?? ''}
          alt={resolveImageAlt(category?.icon, category?.name)}
          width={0}
          height={0}
          className="max-h-10 min-h-10 min-w-10 max-w-10 object-contain object-center"
        />
        <p className="text-sm font-semibold uppercase text-black md:text-base">{category.name}</p>
      </div>
      <MdOutlineKeyboardArrowRight size={24} />
    </Link>
  );
}
